var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffddce",
    d: "m352.371 368.38-51.493-56.282v-68.465h-89.789v68.487l-50.921 56.26z",
    opacity: 1,
    "data-original": "#ffddce"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#407093",
    d: "m401.69 341.695-75.059-22.036L256 400.648l-70.619-80.983-75.066 22.032c-29.301 8.6-49.428 35.483-49.428 66.02v72.434c0 13.448 10.901 24.349 24.349 24.349h341.527c13.448 0 24.349-10.901 24.349-24.349v-72.438c.001-30.535-20.124-57.417-49.422-66.018z",
    opacity: 1,
    "data-original": "#407093",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#365e7d",
    d: "m401.69 341.695-75.059-22.036-34.894 40.012 46.629 13.69c29.298 8.601 49.423 35.483 49.423 66.018V504.5h38.975c13.448 0 24.349-10.902 24.349-24.349v-72.438c0-30.535-20.125-57.417-49.423-66.018z",
    opacity: 1,
    "data-original": "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e4f6ff",
    d: "m117.459 154.258-7.688-8.479H93.337l-7.688 8.479-10.133 59.475c-.956 5.614 3.369 10.738 9.063 10.738h33.949c5.695 0 10.02-5.124 9.063-10.738z",
    opacity: 1,
    "data-original": "#e4f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efc984",
    d: "M297.552 58.569H214.417c-30.054 0-54.418 24.364-54.418 54.418v60.418H351.97v-60.418c0-30.054-24.364-54.418-54.418-54.418z",
    opacity: 1,
    "data-original": "#efc984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eabc6b",
    d: "M297.552 58.569h-8.699v114.836h63.117v-60.418c0-30.054-24.364-54.418-54.418-54.418z",
    opacity: 1,
    "data-original": "#eabc6b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffddce",
    d: "M335.647 165.477c-9.087 0-16.453-7.366-16.453-16.453v-25.013H192.806v25.013c0 9.087-7.366 16.453-16.453 16.453h-16.338v26.905c0 6.875 5.573 12.448 12.448 12.448 2.169 0 3.934 1.699 4.071 3.864 2.625 41.616 37.189 74.561 79.467 74.561s76.842-32.946 79.467-74.561c.137-2.165 1.902-3.864 4.071-3.864 6.875 0 12.448-5.573 12.448-12.448v-26.905z",
    opacity: 1,
    "data-original": "#ffddce"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcbbe",
    d: "M335.647 165.477c-9.087 0-16.453-7.366-16.453-16.453v-25.013h-30.342v92.601c-1.376 28.608-17.839 53.247-41.602 66.15a80.49 80.49 0 0 0 8.749.492c42.278 0 76.842-32.945 79.467-74.561.137-2.165 1.902-3.864 4.071-3.864 6.875 0 12.448-5.573 12.448-12.448v-26.905h-16.338z",
    opacity: 1,
    "data-original": "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#407093",
    d: "m253.41 7.903-152.1 48.379c-8.485 2.699-7.629 14.974 1.149 16.469l153.526 26.148L409.51 72.75c8.777-1.495 9.633-13.77 1.149-16.469l-152.1-48.379a8.498 8.498 0 0 0-5.149.001z",
    opacity: 1,
    "data-original": "#407093",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a80aa",
    d: "M350.792 126.379H161.208a7.361 7.361 0 0 1-7.361-7.361V81.502l84.186-10.417a146.247 146.247 0 0 1 35.902-.001l84.218 10.418v37.516a7.361 7.361 0 0 1-7.361 7.361z",
    opacity: 1,
    "data-original": "#4a80aa"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#365e7d",
    d: "M410.659 56.281 272.53 12.346v44.018c0 9.043 7.297 16.376 16.323 16.446V93.3l120.658-20.55c8.777-1.495 9.633-13.77 1.148-16.469z",
    opacity: 1,
    "data-original": "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#407093",
    d: "M288.853 72.93v53.449h61.939a7.361 7.361 0 0 0 7.361-7.361V81.502z",
    opacity: 1,
    "data-original": "#407093",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe07d",
    d: "M117.459 154.258h-31.81v-20.881a8.034 8.034 0 0 1 8.034-8.034h15.743a8.034 8.034 0 0 1 8.034 8.034v20.881z",
    opacity: 1,
    "data-original": "#ffe07d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4a80aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.878 287.034c0 29.129-8.456 57.631-24.34 82.047L256 400.648l114.581-68.086zM211.122 287.034c0 29.129 8.456 57.631 24.34 82.047L256 400.648l-114.581-68.086z",
    fill: "#4a80aa",
    opacity: 1,
    "data-original": "#4a80aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f4fbff",
    d: "M294.247 331.144c-11.784 2.594-24.698 4.033-38.247 4.033s-26.463-1.439-38.247-4.033a150.392 150.392 0 0 0 17.71 37.937L256 400.648l20.537-31.567a150.376 150.376 0 0 0 17.71-37.937z",
    opacity: 1,
    "data-original": "#f4fbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.802 334.499-30.049-8.823-65.376-42.701v-9.784c18.928-14.277 31.926-36.1 34.342-61.115 9.493-1.528 16.766-9.777 16.766-19.693v-26.905c0-.104-.011-.206-.016-.31v-34.082a14.787 14.787 0 0 0 6.182-12.067v-31.19l45.117-7.685c7.415-1.263 12.747-7.152 13.271-14.655.522-7.503-3.941-14.075-11.108-16.354L260.834.757a15.914 15.914 0 0 0-9.698-.001L99.037 49.135c-7.167 2.279-11.631 8.851-11.108 16.353.332 4.767 2.61 8.877 6.126 11.569v40.787h-.372c-8.565 0-15.533 6.968-15.533 15.533v20.246l-10.027 58.852c-1.733 10.179 6.107 19.496 16.457 19.496h33.949c10.327 0 18.194-9.295 16.457-19.497l-10.027-58.851v-20.246c0-8.565-6.968-15.533-15.533-15.533h-.371V81.481l37.294 6.352v31.186c0 4.927 2.389 9.331 6.153 12.043l.014 34.419v26.902c0 9.917 7.273 18.165 16.766 19.693 2.415 25.001 15.399 46.814 34.309 61.092v9.83l-65.362 42.693-30.025 8.813c-32.129 9.43-54.815 38.927-54.815 73.215v22.352c0 4.142 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-22.352c0-27.024 18.109-51.213 44.04-58.823l27.976-8.212 111.766 66.413c2.269 1.348 5.271 1.42 7.662 0l111.773-66.417 27.973 8.212c25.927 7.612 44.036 31.8 44.036 58.822v72.438c0 9.291-7.559 16.85-16.85 16.85h-33.057v-32.328a7.5 7.5 0 0 0-7.5-7.5 7.5 7.5 0 0 0-7.5 7.5v32.328H133.26v-32.328c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v32.328H85.237c-9.291 0-16.85-7.559-16.85-16.85V465.13c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v15.021c0 17.562 14.287 31.849 31.849 31.849h341.527c17.562 0 31.849-14.287 31.849-31.849v-72.438c0-33.48-21.912-63.555-54.81-73.214zM118.528 216.971H84.58a1.69 1.69 0 0 1-1.671-1.978l9.07-53.236h19.15l9.07 53.235a1.69 1.69 0 0 1-1.671 1.979zm-8.569-83.594v13.381H93.148v-13.381c0-.295.239-.534.534-.534h15.742a.533.533 0 0 1 .535.534zm119.218 239.794 2.985 4.588-76.569-45.497 48.601-31.745c2.204 25.86 10.728 50.745 24.983 72.654zm-.052-32.375c17.653 2.508 36.087 2.51 53.75 0a143.248 143.248 0 0 1-12.624 24.196L256 386.896l-14.251-21.904a143.248 143.248 0 0 1-12.624-24.196zm53.698 32.375c14.255-21.909 22.779-46.794 24.982-72.654l48.601 31.744-76.568 45.498zm43.871-239.292h17.776v24.098h-8.823c-4.937 0-8.954-4.016-8.954-8.953v-15.145zm-223.111-70.45 152.101-48.38a.986.986 0 0 1 .603.001l152.1 48.379c.314.1.745.236.69 1.017-.055.78-.5.855-.826.911l-50.288 8.565-18.88-2.335a7.5 7.5 0 0 0-1.84 14.886l13.41 1.659v30.748l-189.305-.007V88.131l77.607-9.603a138.926 138.926 0 0 1 34.06 0l29.373 3.633a7.5 7.5 0 0 0 1.842-14.886l-29.373-3.633a153.855 153.855 0 0 0-37.743 0L154.02 73.924l-50.303-8.567c-.326-.056-.771-.131-.826-.911-.054-.781.377-.918.692-1.017zm63.928 94.548-.01-24.098h17.805v15.146c0 4.936-4.016 8.953-8.954 8.953h-8.841zm16.507 50.244c-.386-6.107-5.462-10.891-11.555-10.891a4.954 4.954 0 0 1-4.949-4.948v-19.405h8.838c13.207 0 23.953-10.745 23.953-23.952v-15.146h111.389v15.146c0 13.207 10.746 23.952 23.953 23.952h8.838v19.405a4.954 4.954 0 0 1-4.949 4.948c-6.093 0-11.169 4.784-11.555 10.892-2.389 37.869-34.007 67.534-71.982 67.534s-69.592-29.665-71.981-67.535zM256 290.755a86.566 86.566 0 0 0 37.378-8.473v4.753c0 12.823-1.73 25.472-5.061 37.672-20.382 3.886-43.425 4.043-64.634 0a142.926 142.926 0 0 1-5.061-37.672c0-.159-.022-.314-.032-.471-.002-.031.001-.062-.001-.093v-4.204A86.577 86.577 0 0 0 256 290.755z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.f867853a2d1cb742672ce2fb06714da7.svg";
export { ForwardRef as ReactComponent };